import React from 'react';
import { Route } from 'react-router-dom';
import ProjectPage from './ProjectPage';

export const routes = [<Route key="0" path="/project" component={ProjectPage} />];

export const navigation = { name: 'project', link: '/project', icon: 'Property', parent: 'BoardMembers' };
